<template>
  <div>
    <div class="select-c">
      <span>选择机构:</span>
      <el-select default-first-option style="width:280px" v-model="partnerId">
        <el-option :value.number="partner.id" :label="partner.title" v-for="partner in partnerList"></el-option>
      </el-select>
    </div>
    <el-form ref="form" label-width="150px" class="form" v-if="partnerId">
        <!-- <el-form-item label="是否显示">
            <el-switch v-model="info.is_show"></el-switch>
          </el-form-item> -->
        <el-form-item label="套餐1显示">
            <el-switch off-value="0" on-value="1" v-model="info.is_show_month"></el-switch>
        </el-form-item>
        <el-form-item label="套餐1名称">
            <el-input v-model="info.month_title" placeholder="默认为“月度会员”"></el-input>
        </el-form-item>
        <el-form-item label="套餐1服务时长(天)">
            <el-input v-model="info.month_time"  placeholder="默认为31"></el-input>
        </el-form-item>
        <el-form-item label="套餐1价格">
            <el-input v-model="info.month_price"></el-input>
        </el-form-item>
        <el-form-item label="套餐1划线价">
            <el-input v-model="info.month_underline_price"></el-input>
        </el-form-item>
        <el-form-item label="套餐2显示">
            <el-switch  :off-value="0" :on-value="1"  v-model="info.is_show_year"></el-switch>
        </el-form-item>
        <el-form-item label="套餐2名称">
            <el-input v-model="info.year_title" placeholder="默认为“年度会员”"></el-input>
        </el-form-item>
        <el-form-item label="套餐2服务时长(天)">
            <el-input v-model="info.year_time"  placeholder="默认为365"></el-input>
        </el-form-item>
        <el-form-item label="套餐2价格">
            <el-input v-model="info.year_price"></el-input>
        </el-form-item>
        <el-form-item label="套餐2划线价">
            <el-input v-model="info.year_underline_price"></el-input>
        </el-form-item>
        <el-form-item label="服务期描述">
            <el-input v-model="info.date_desc"></el-input>
        </el-form-item>
        <el-form-item label="会员权益">
            <el-input type="textarea" rows="5" v-model="info.rule_1"></el-input>
        </el-form-item>
        <el-form-item label="服务声明">
            <el-input type="textarea" rows="5" v-model="info.rule_2"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submit">保存</el-button>
        </el-form-item>
    </el-form>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'VipSetting',
  props: {
    type: {
      type: 'string',
      default: _ => {
        return 'normal'
      }
    }
  },
  data () {
    return {
        info: {},
        partnerId: null,
        partnerList: []
    }
  },
  mounted () {
    this.getPartnerList()
  },
  watch: {
    partnerId () {
      this.fetchData()
    }
  },
  methods: {
    fetchData () {
      request({
        url: '/partner-vip-setting',
        method: 'GET',
        params: {
          partner_id: this.partnerId,
          type: this.type,
        }
      }).then(res => {
        this.info = res.data.setting || {}

        this.info.month_price /= 100
        this.info.year_price /= 100
        this.info.month_underline_price /= 100
        this.info.year_underline_price /= 100
      })
    },
    getPartnerList () {
      request({
        url: '/partners',
      }).then(res => {
        this.partnerList = res.data.list
        if (this.partnerList.length > 0)
          this.partnerId = this.partnerList[0].id
      })
    },
    submit() {
        request({
          url: '/partner-vip-setting',
          method: 'POST',
          data: {
            partner_id: this.partnerId,
            type: this.type,
            setting: {
              ...this.info,
              month_price: this.info.month_price * 100,
              year_price: this.info.year_price * 100,
              month_underline_price: this.info.month_underline_price * 100,
              year_underline_price: this.info.year_underline_price * 100,
            }
          }
        }).then(res => {
            this.$message.success('保存成功!')
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.form {
    width: 800px;
}
.select-c {
  padding: 20px 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/partnerVip/setting.vue